import React from 'react';
import * as Actions from '../../../actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import Switch from './Switch'
import { Slider, Switch, Radio } from 'antd';
import { parameterLength } from '../../../actions';

const RadioGroup = Radio.Group;

class UIControls extends React.Component {
  state = {
    checked: true,
    configurationType: 'Double Double'
  };

  toggleUXSwitch = () => {
    this.setState({ checked: !this.state.checked }, () => {
      const { checked } = this.state;
      this.props.changeUXPath(checked ? 'bikes' : 'dimensions');
    });
  };
  changeConfigurationType = (e) => {
    this.setState({ configurationType: e.target.value }, () => {
      this.props.changeConfigurationType(this.state.configurationType);
    });
  };
  render() {
    const { checked, configurationType } = this.state;
    const {
      parameters: { renderBikes, rows, columns, width, length, count },
      actions: {
        toggleRenderBikes,
        parameterRows,
        parameterColumns,
        parameterLength,
        parameterWidth,
        parameterBikeCount
      }
    } = this.props;
    return (
      <div
        className='dashboard-container'
        onMouseEnter={() => {
          this.props.actions.mouseOverDashboard(true);
        }}
        onMouseLeave={() => {
          this.props.actions.mouseOverDashboard(false);
        }}
      >
        <div className='title'>Ground Control Algorithm Interface</div>
        <Switch
          unCheckedChildren='User Enters Dimensions'
          checkedChildren='User Enters Bikes'
          className='ui-switch'
          onChange={this.toggleUXSwitch}
          checked={checked}
        />
        <div className='radio-container'>
          <RadioGroup
            onChange={this.changeConfigurationType}
            value={configurationType}
          >
            <Radio value={'Double Double'}>Double Double</Radio>
            <Radio value={'Vertical Double'}>Vertical Double</Radio>
            <Radio value={'Varsity Double'}>Varsity Double</Radio>
            <Radio value={'Varsity Vertical'}>Varsity Vertical</Radio>
          </RadioGroup>
        </div>

        {!checked && (
          <div className='ui-slider'>
            Width{' '}
            <Slider
              value={width}
              onChange={parameterWidth}
              max={100}
              min={16}
              step={0.1}
            />
          </div>
        )}
        {!checked && (
          <div className='ui-slider'>
            Length{' '}
            <Slider
              value={length}
              onChange={parameterLength}
              max={100}
              min={16}
              step={0.1}
            />
          </div>
        )}
        {checked && (
          <div className='ui-slider'>
            Bikes{' '}
            <Slider
              value={count}
              onChange={parameterBikeCount}
              max={100}
              min={8}
            />
          </div>
        )}

        {/* Render Bikes <Switch size="small" checked={renderBikes} onChange={toggleRenderBikes} /> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    parameters: state.parameters
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UIControls);



// WEBPACK FOOTER //
// ./src/components/Results/UIControls/size.js